import { cva } from 'class-variance-authority';

export const mapVariants = cva(
  'mb-4 flex w-full items-center justify-center rounded-2xl bg-cover bg-center bg-no-repeat',
  {
    variants: {
      size: {
        default: 'h-24',
        normal: 'h-40',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);
